// @flow
import { combineReducers } from 'redux';

import Auth from './auth/reducers';
import Layout from './layout/reducers';
import Hospital from './hospital/reducers'
import IssueType from './issueType/reducers';
import ServiceOption from './serviceOption/reducers';
import Team from './team/reducers';
import Product from './product/reducers';
import RequestFeature from './requestFeature/reducers';
import User from './user/reducers';
import Menu from './menu/reducers';
import Privillege from './privillege/reducers';
import Sprint from './sprint/reducers';
import Comment from './comment/reducers';
import WorkSchedule from './workSchedule/reducers';

export default (combineReducers({
    Auth,
    Layout,
    Hospital,
    IssueType,
    ServiceOption,
    Team,
    Product,
    RequestFeature,
    User,
    Menu,
    Privillege,
    Sprint,
    Comment,
    WorkSchedule,
}));
